import { render } from "./NutrableProgramPromo.vue?vue&type=template&id=0008b169&scoped=true"
import script from "./NutrableProgramPromo.vue?vue&type=script&lang=js"
export * from "./NutrableProgramPromo.vue?vue&type=script&lang=js"

import "./NutrableProgramPromo.vue?vue&type=style&index=0&id=0008b169&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0008b169"]])

export default __exports__